package kz.dentalcrm.app.di

import com.russhwolf.settings.Settings
import kz.dentalcrm.app.core.storage.Settings
import kz.dentalcrm.app.data.AppointmentRepositoryImpl
import kz.dentalcrm.app.data.AuthRepositoryImpl
import kz.dentalcrm.app.data.DiagnosisRepositoryImpl
import kz.dentalcrm.app.data.InitialInspectionRepositoryImpl
import kz.dentalcrm.app.data.PositionsRepositoryImpl
import kz.dentalcrm.app.data.QuickRepliesRepositoryImpl
import kz.dentalcrm.app.data.ServicesRepositoryImpl
import kz.dentalcrm.app.data.TreatmentRepositoryImpl
import kz.dentalcrm.app.domain.AppointmentRepository
import kz.dentalcrm.app.domain.AuthRepository
import kz.dentalcrm.app.domain.DiagnosisRepository
import kz.dentalcrm.app.domain.InitialInspectionRepository
import kz.dentalcrm.app.domain.PositionsRepository
import kz.dentalcrm.app.domain.QuickRepliesRepository
import kz.dentalcrm.app.domain.ServicesRepository
import kz.dentalcrm.app.domain.TreatmentRepository
import org.koin.dsl.module

fun repositoryModule() = module {
    single<Settings> { Settings() }
    factory<AuthRepository> {
        AuthRepositoryImpl(
            authApi = get(),
            storage = get()
        )
    }
    factory<AppointmentRepository> {
        AppointmentRepositoryImpl(
            mainApi = get()
        )
    }
    factory<ServicesRepository> {
        ServicesRepositoryImpl(
            servicesServiceApi = get()
        )
    }
    factory<DiagnosisRepository> {
        DiagnosisRepositoryImpl(
            diagnosisApi = get()
        )
    }
    factory<TreatmentRepository> {
        TreatmentRepositoryImpl(
            treatmentApi = get()
        )
    }
    factory<PositionsRepository> {
        PositionsRepositoryImpl(
            positionsApi = get()
        )
    }
    factory<InitialInspectionRepository> {
        InitialInspectionRepositoryImpl(
            initialInspectionApi = get()
        )
    }
    factory<QuickRepliesRepository> {
        QuickRepliesRepositoryImpl(
            quickRepliesApi = get()
        )
    }
}